





















































































































































import { Component } from 'vue-property-decorator';
import VNavigator from '@/components/items/VNavigator.vue';
import Mixin from '@/mixin';
import { validationMixin, Vuelidate } from 'vuelidate';
import {
  signUpValidator,
  TSignUp
} from '@/config/validation/sign-up-validator';
import { SignUpOptions } from '@/store/models';
import VDropDown from '@/components/items/VCustomDropDown.vue';
import authService from '@/services/common/auth.service';
import popupModule from '@/store/modules/common/popup.module';
import popup from '@/data/popup.json';
import authModule from '@/store/modules/common/auth.module';
import VMessage from '@/components/items/VMessage.vue';

@Component({
  mixins: [validationMixin],
  name: 'register',
  validations: signUpValidator,
  components: { VMessage, VDropDown, VNavigator }
})
export default class Register extends Mixin {
  public signUp: SignUpOptions = {
    display_name: '',
    username: '',
    password: '',
    passwordConfirmation: '',
    email: '',
    phone: ''
  };
  public responseError = false;

  get vSignUp() {
    return (this.$v as Vuelidate<TSignUp>).signUp;
  }

  get allowSubmit() {
    return !(this.vSignUp?.$error || this.vSignUp?.$invalid);
  }

  public async register() {
    this.vSignUp?.$touch();
    // if (this.allowSubmit) {
    //   const authentication = await authService.register(this.signUp);
    //   if (authentication) {
    //     await Promise.all([
    //       authModule.setAuthentication(authentication),
    //       this.showPopup(true)
    //     ]);
    //   }
    // }
  }

  public async showPopup(isShow: boolean) {
    await Promise.all([
      popupModule.initPopup(popup.register),
      popupModule.setPayload(this.signUp.display_name),
      popupModule.setShowPopup(isShow)
    ]);
  }

  async beforeMount() {}
}
